module.exports = __webpack_public_path__ + "b8a2d76ec11f11537d0dae0923198078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/category-headers/crm.svg
// module id = 1929
// module chunks = 0